// extracted by mini-css-extract-plugin
export default {"wrapper":"declarationPage_wrapper__0kp26","container":"declarationPage_container__biMY8"};